import { ITip } from "@/schemas/ITip";
import { BaseRepository } from "@/repository/base";

const tipRepository = new BaseRepository<ITip>("tips");

export default tipRepository;
